/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeAOffIcon16Light } from './MediaAudioVolumeAOffIcon16Light';
import { MediaAudioVolumeAOffIcon16Regular } from './MediaAudioVolumeAOffIcon16Regular';
import { MediaAudioVolumeAOffIcon16Solid } from './MediaAudioVolumeAOffIcon16Solid';
import { MediaAudioVolumeAOffIcon20Light } from './MediaAudioVolumeAOffIcon20Light';
import { MediaAudioVolumeAOffIcon20Regular } from './MediaAudioVolumeAOffIcon20Regular';
import { MediaAudioVolumeAOffIcon20Solid } from './MediaAudioVolumeAOffIcon20Solid';
import { MediaAudioVolumeAOffIcon24Regular } from './MediaAudioVolumeAOffIcon24Regular';
import { MediaAudioVolumeAOffIcon24Solid } from './MediaAudioVolumeAOffIcon24Solid';
import { MediaAudioVolumeAOffIcon32Regular } from './MediaAudioVolumeAOffIcon32Regular';
import { MediaAudioVolumeAOffIcon64Regular } from './MediaAudioVolumeAOffIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeAOffIcon16Light,
        regular: MediaAudioVolumeAOffIcon16Regular,
        solid: MediaAudioVolumeAOffIcon16Solid,
    },
    20: {
        light: MediaAudioVolumeAOffIcon20Light,
        regular: MediaAudioVolumeAOffIcon20Regular,
        solid: MediaAudioVolumeAOffIcon20Solid,
    },
    24: {
        regular: MediaAudioVolumeAOffIcon24Regular,
        solid: MediaAudioVolumeAOffIcon24Solid,
    },
    32: {
        regular: MediaAudioVolumeAOffIcon32Regular,
    },
    64: {
        regular: MediaAudioVolumeAOffIcon64Regular,
    },
};
export var MediaAudioVolumeAOffIcon = forwardRef('MediaAudioVolumeAOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
